import { Component, inject } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { FgdsProductType, LocalizeProductTypePipe } from "@domain/product/product";
import { Modal, ModalRef } from "@odx/angular/components/modal";

@Component({
  selector: "app-select-placeholder-modal",
  imports: [UiKitModule, FormsModule, ReactiveFormsModule, LocalizeProductTypePipe],
  templateUrl: "./select-placeholder-modal.component.html",
  styleUrl: "./select-placeholder-modal.component.scss",
})
export class SelectPlaceholderModalComponent implements Modal<FgdsProductType[], FgdsProductType> {
  public readonly modalRef: ModalRef<FgdsProductType[], FgdsProductType>;

  protected readonly ProductType = FgdsProductType;
  protected productTypeForm: FormGroup;

  protected productTypes: FgdsProductType[];

  constructor() {
    const formBuilder = inject(FormBuilder);
    const modalRef = inject<ModalRef<FgdsProductType[], FgdsProductType>>(ModalRef);

    this.modalRef = modalRef;
    this.productTypes = modalRef.data;
    this.productTypeForm = formBuilder.group({
      productType: [this.productTypes[0], [Validators.required]],
    });
  }

  onConfirm() {
    this.modalRef.close(this.productTypeForm.value.productType);
  }
}
